import { render, staticRenderFns } from "./ArchiveCandidateDialog.vue?vue&type=template&id=bfa21138"
import script from "./ArchiveCandidateDialog.vue?vue&type=script&lang=js"
export * from "./ArchiveCandidateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports